import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import UserService from "../../../../services/UserService";
import TenantSelectionCard from "../Components/TenantSelectionCard";
import FilterTenant from "../Pages/FilterTenant";
import { useApp } from "../../../../context/AppContext";
import { getTenantText } from "../../../../utils/translationHelpers";
import { IButtonAction, handleRedirect } from "../../../../utils/CommonFunctions";
import Button from "../../../Reusable/Button";

interface TenantManagerProps {
    items: Array<any>,
    setItems: React.Dispatch<React.SetStateAction<Array<any>>>,
}

const TenantManager = ({ items, setItems }:TenantManagerProps) => {
  const [t] = useTranslation("translations");
  const {tenantFilter} = useApp();
  const history = useNavigate();

  const [locations, setLocations] = useState<Array<any>>(
    UserService.getAttribute("locations")
  );

  useEffect(() => {
    setTimeout(() => {

      setLocations(UserService.getAttribute("locations"))
    }, 1000)
  }, [])

  const tenants = window.config.tenants ?? window.config.ohts;

  const handleFilterButtonClick = () => {
    const buttonAction: IButtonAction = {
      type: "IN_APP",
      url: `${window.location.origin}/LOCATION_SELECTION/${FilterTenant.displayName}`,
    }
    const pageName = "";
    const title = "";
    handleRedirect(buttonAction, history, title, pageName);
  };

  return (
    <div className="ls__ohts">
      {locations.length > 0 ? (
        <div className="ls__ohts__container">
          <p className="ls__pageheader">{t("LocationSelection.SelectTenant.TeamsNearYou", {tenant_plural: getTenantText("tenant_plural")})}</p>
          <div className="ls__ohts__grid">
            {window.config.tenantsNearYou.map((props) => <TenantSelectionCard {...props} type="tenant" key={props.id} checkList={items} setCheckList={setItems} />)}
          </div>
        </div>
      ) : (
        null
      )}

      <div className="ls__ohts__container">
        <div className="ls__pageheader_container">
          <p className="ls__pageheader">{t("LocationSelection.SelectTenant.AllOntarioHealthTeams", {tenant_plural: getTenantText("tenant_plural")})}</p>
          <Button 
            buttonType="IN_APP"
            buttonClassname="ls__link" 
            buttonText={t("LocationSelection.SelectTenant.filter")}
            handleRedirect={(()=> handleFilterButtonClick())}
            showButtonIcon={false}
            buttonIconImage=""
            buttonIconClassname=""
            buttonIconPosition=""
          />
        </div>
        <div className="ls__ohts__grid">
          {tenants
            .filter((item) => {
              if (tenantFilter === "" || tenantFilter === "all_regions") {
                return item
              }
              return item.region === tenantFilter
            })
            .map((props) => <TenantSelectionCard {...props} type="tenant" key={props.id} checkList={items} setCheckList={setItems} />)}
        </div>
      </div>
    </div>
  );
};

export default TenantManager;
